import { Helmet } from 'react-helmet-async';

import ForgotPasswordView from '@src/features/forgot-password/view';
import useLocales from '@src/locales/use-locales';

const ForgotPassword = () => {
  const { t } = useLocales();

  return (
    <>
      <Helmet>
        <title>{t('titles.forgotPassword', { ns: 'meta' })}</title>
      </Helmet>

      <ForgotPasswordView />
    </>
  );
};

export default ForgotPassword;
